import React from "react";
import { connect } from "react-redux";
import NewsletterSection from "./NewsletterSection";
import { getSectionId, getSections } from "../../../redux/selectors/sections";
import { SectionBreakLine } from "./BreakLines";
import {
    getContentPaneErrorHTML,
    getCurrentDataIsLoading,
} from "../../../redux/selectors/errors";

const NewsletterSections = props => {
    const {
        sections,
        getSectionId,
        currentDataIsLoading,
        contentPaneErrorHTML,
    } = props;

    if (sections.length) {
        return (
            <div className="newsletter-content-area">
                {sections.map((section, index) => (
                    <div key={section.id}>
                        <NewsletterSection
                            id={getSectionId(section.id)}
                            section={section}
                        />
                        {index < sections.length - 1 && <SectionBreakLine />}
                    </div>
                ))}
            </div>
        );
    } else {
        if (currentDataIsLoading) {
            return (
                <div className="newsletter-content-area text-center p-5 loading">
                    <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            );
        } else {
            return (
                <div
                    className="newsletter-content-area p-5"
                    dangerouslySetInnerHTML={{ __html: contentPaneErrorHTML }}
                />
            );
        }
    }
};

/**
 * mapStateToProps returns the parts of the state that will be available as props
 * @param state
 * @returns {{navigation: *}}
 */
const mapStateToProps = state => {
    return {
        sections: getSections(state),
        getSectionId: id => getSectionId(state, id),
        currentDataIsLoading: getCurrentDataIsLoading(state),
        contentPaneErrorHTML: getContentPaneErrorHTML(state),
    };
};

/**
 * mapDispatchToProps exposes the actions we want to call as props
 * @param state
 * @returns {{navigation: *}}
 */
const mapDispatchToProps = dispatch => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(NewsletterSections);
